import React from 'react';
import {
    change as changeFieldValue, Field, formValueSelector, reduxForm,
} from 'redux-form';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {
    maxValueMonetario,
    minValueMonetario,
    renderFieldCheck,    
    renderFieldMonetarioFormulario,
    renderFieldNumerosPorcentagem,
    renderFieldText, required, tamanhoPorcentagem,
} from '../../util/inputs';
import {arredondamentoPadrao, realParaNumber} from '../../util/numberUtil';
import {adicionarFormasPagamento} from '../../actions/viagem/adicionarFormasPagamento';
import listarDispositivosStoneUsuarioLogado from '../../actions/empresa/listarDispositivosStoneUsuarioLogado';
import { validaPerfis } from '../../security/Autorizacao';
import { getAdminEmpresa, 
         getGestorEmpresa, 
         getOperadorEmpresa, 
         getOperadorRemarcacao } 
from '../../security/securityContext';

const LABEL_MEIO_PAGAMENTO_STONE = { credit: 'Crédito', debit: 'Débito', pix: 'PIX' };

export const validate = (values, props) => {
    const errors = {};

    const checkMaxValue = (field, max, message) => {
        if (values[field] && Number(values[field]) > Number(max)) {
            errors[field] = message;
        }
    };

    // Verificações para garantir que os objetos viagemIda e viagemVolta existam
    if (props.viagemIda) {
        checkMaxValue('descontoIda', props.viagemIda.descontoMaximoUsuarioRota, `Desconto máximo permitido é ${props.viagemIda.descontoMaximoUsuarioRota} %`);
        checkMaxValue('acrescimoPassagemIda', props.viagemIda.acrescimoMaximoPassagem, `Acréscimo máximo passagem é ${props.viagemIda.acrescimoMaximoPassagem} %`);
    }

    if (props.viagemVolta) {
        checkMaxValue('descontoVolta', props.viagemVolta.descontoMaximoUsuarioRota, `Desconto máximo permitido é ${props.viagemVolta.descontoMaximoUsuarioRota} %`);
        checkMaxValue('acrescimoPassagemVolta', props.viagemVolta.acrescimoMaximoPassagem, `Acréscimo máximo passagem é ${props.viagemVolta.acrescimoMaximoPassagem} %`);
    }

    const validateTotal = (fields) => {
        const valorTotal = arredondamentoPadrao(fields.reduce((acc, field) => acc + realParaNumber(values[field]), 0));
        if (valorTotal !== props.totalReserva) {
            fields.forEach(field => {
                errors[field] = 'A soma dos valores deve ser igual ao valor total';
            });
        }
    };

    // Verificar se pelo menos um checkbox está marcado
    const checkboxes = ['cartaoCredito', 'cartaoDebito', 'dinheiro', 'pix', 'pagamentoTEF', 'pagamentoLink', 'pagamentoCieloEcommerce', 'pagamentoSicoob', 'pagamentoStoneConnect'];
    const anyCheckboxChecked = checkboxes.some(field => values[field]);

    if (!anyCheckboxChecked) {
        errors.pagamento = 'Pelo menos uma opção de pagamento deve ser selecionada';
    }

    if (props.pagamentoTEF) {
        if (values.valorTEF && values.dinheiro) {
            validateTotal(['valorTEF', 'valorDinheiro']);
        } else {
             validateTotal(['valorTEF']);
        }
    } else if (props.pagamentoLink) {
        validateTotal(['valorLink']);
    } else if (props.pagamentoCieloEcommerce) {
        validateTotal(['valorCieloEcommerce']);
    } else if (props.pagamentoSicoob) {
        validateTotal(['valorSicoob']);
    } else if (props.pagamentoStoneConnect) {
        validateTotal(['valorStoneConnect']);
        if (!values.numeroSerieDispositivoStone) {
            errors.numeroSerieDispositivoStone = 'Selecione a maquininha';
        }
        if ((values.modoStoneConnect || 'PAGAMENTO_DIRETO') === 'PAGAMENTO_DIRETO' && !values.tipoPagamentoStoneConnect) {
            errors.tipoPagamentoStoneConnect = 'Selecione a forma de pagamento na maquininha';
        }
    } else {
        if (values.cartaoCredito && values.pix && values.dinheiro) {
                validateTotal(['valorCartaoCredito', 'valorPIX', 'valorDinheiro']);
            } else if (values.cartaoDebito && values.pix && values.dinheiro) {
                validateTotal(['valorCartaoDebito', 'valorPIX', 'valorDinheiro']);
            } else if (values.cartaoCredito && values.dinheiro) {
                validateTotal(['valorCartaoCredito', 'valorDinheiro']);
            } else if (values.cartaoDebito && values.dinheiro) {
                validateTotal(['valorCartaoDebito', 'valorDinheiro']);
            } else if (values.pix && values.dinheiro) {
                validateTotal(['valorPIX', 'valorDinheiro']);
            } else if (values.pix && values.cartaoCredito) {
                validateTotal(['valorPIX', 'valorCartaoCredito']);
            } else if (values.pix && values.cartaoDebito) {
                validateTotal(['valorPIX', 'valorCartaoDebito']);
                // eslint-disable-next-line no-dupe-else-if
            } else if (values.cartaoCredito && values.cartaoDebito && values.dinheiro && values.pix) {
                validateTotal(['valorCartaoCredito', 'valorCartaoDebito', 'valorPIX', 'valorDinheiro']);
                // eslint-disable-next-line no-dupe-else-if
            } else if (values.cartaoCredito && values.cartaoDebito && values.dinheiro) {
                validateTotal(['valorCartaoCredito', 'valorCartaoDebito', 'valorDinheiro']);
            } else if (values.cartaoCredito && values.cartaoDebito) {
                validateTotal(['valorCartaoCredito', 'valorCartaoDebito']);
            } else if (values.cartaoCredito) {
                if (realParaNumber(values.valorCartaoCredito) !== props.totalReserva) {
                    errors.valorCartaoCredito = 'Valor deve ser igual ao valor total';
                }
                if (values.quantidadeParcelas && !values.quantidadeParcelas.match(/^[0-9]+$/)) {
                    errors.quantidadeParcelas = 'Valor deve ser um número inteiro';
                }
            } else if (values.cartaoDebito) {
                if (realParaNumber(values.valorCartaoDebito) !== props.totalReserva) {
                    errors.valorCartaoDebito = 'Valor deve ser igual ao valor total';
                }
            } else if (values.pix) {
                if (realParaNumber(values.valorPIX) !== props.totalReserva) {
                    errors.valorPIX = 'Valor deve ser igual ao valor total';
                }
            } else if (values.dinheiro) {
                if (realParaNumber(values.valorDinheiro) !== props.totalReserva) {
                    errors.valorDinheiro = 'Valor deve ser igual ao valor total';
                }
            }

    }




    return errors;
};


export class FormCadastrarFormaPagamento extends React.Component {

    constructor(props) {
        super(props);
        this.state = { dispositivosStoneUsuarioLogado: [] };
    }

    componentDidMount() {
        if (this.props.usuariosEmpresa.habilitadoStoneConnect && this.props.empresaSelecionada) {
            this.props.listarDispositivosStoneUsuarioLogado(this.props.empresaSelecionada.id)
                .then(resp => {
                    this.setState({ dispositivosStoneUsuarioLogado: resp.data });
                    // pré-seleciona a primeira maquininha do usuário para poupar um clique
                    // (caso comum: só 1 maquininha vinculada)
                    if (resp.data.length > 0 && !this.props.numeroSerieDispositivoStone) {
                        this.props.changeFieldValue('formReserva', 'numeroSerieDispositivoStone', resp.data[0].numeroSerie);
                    }
                });
            // mesma lógica de poupar um clique da maquininha: se a empresa só tem 1 meio
            // de pagamento Stone habilitado, já vem selecionado
            const meiosHabilitados = this.props.empresaSelecionada.meiosPagamentoStoneHabilitados || [];
            if (meiosHabilitados.length === 1 && !this.props.tipoPagamentoStoneConnect) {
                this.props.changeFieldValue('formReserva', 'tipoPagamentoStoneConnect', meiosHabilitados[0]);
            }
            // idem para o modo de criação do pedido -- se só 1 estiver habilitado para a
            // empresa, os botões nem aparecem (ver render), então precisa vir pré-selecionado
            const modosHabilitados = this.props.empresaSelecionada.modosCriacaoPedidoStoneHabilitados || [];
            if (modosHabilitados.length === 1 && !this.props.modoStoneConnect) {
                this.props.changeFieldValue('formReserva', 'modoStoneConnect', modosHabilitados[0]);
            }
        }
        const pagamentos = []
        pagamentos.push({
            tipo: 'Dinheiro',
            base64Comprovante: '',
            numeroComprovante: '',
            valor: realParaNumber(this.props.valorDinheiro),
            quantidadeParcelas: 1,
        });
        if(this.props.usuariosEmpresa.habilitadoPagamentoViaTEF) {
            pagamentos.push({
                tipo: 'TEF',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: realParaNumber(this.props.valorTEF),
                quantidadeParcelas: 1,
            });
        }
        if(this.props.usuariosEmpresa.habilitadoPagamentoViaLink) {
            pagamentos.push({
                tipo: 'Link Pagamento',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: realParaNumber(this.props.valorLink),
                quantidadeParcelas: 1,
            });
        }
        if(this.props.usuariosEmpresa.habilitadoCieloEcommerce) {
            pagamentos.push({
                tipo: 'Cielo E-commerce PIX',
                codigoTipo: 'CIELO_ECOMMERCE',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: realParaNumber(this.props.valorCieloEcommerce),
                quantidadeParcelas: 1,
            });
        }
        if(this.props.usuariosEmpresa.habilitadoSicoob) {
            pagamentos.push({
                tipo: 'Sicoob PIX',
                codigoTipo: 'SICOOB',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: realParaNumber(this.props.valorSicoob),
                quantidadeParcelas: 1,
            });
        }
        if(this.props.usuariosEmpresa.habilitadoStoneConnect) {
            pagamentos.push({
                tipo: 'Connect Stone',
                codigoTipo: 'STONE_CONNECT',
                base64Comprovante: '',
                numeroComprovante: '',
                valor: realParaNumber(this.props.valorStoneConnect),
                quantidadeParcelas: this.props.parcelasStoneConnect || 1,
                // campos extras exigidos pelo backend (ComandoCriacaoRemarcacaoReservasDto) além do
                // FormaPagamentoDto padrão -- ver AbaResumoCompra.js/montarParametroReserva, que os
                // eleva para o nível raiz do comando de criação da reserva
                numeroSerieDispositivoStone: this.props.numeroSerieDispositivoStone,
                modoStoneConnect: this.props.modoStoneConnect || 'PAGAMENTO_DIRETO',
                tipoPagamentoStoneConnect: this.props.tipoPagamentoStoneConnect,
                parcelasStoneConnect: this.props.parcelasStoneConnect || 1,
            });
        }
        this.props.adicionarFormasPagamento(pagamentos);
    }

    componentDidUpdate(prevProps) {

        if (!prevProps.pagamentoTEF && this.props.pagamentoTEF) {

             // Preenche valorTEF com total da reserva
            this.props.changeFieldValue(
                'formReserva',
                'valorTEF',
                this.props.totalReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
            );
            // limpando os checkboxes
            this.props.changeFieldValue('formReserva', 'cartaoCredito', false);
            this.props.changeFieldValue('formReserva', 'cartaoDebito', false);
            this.props.changeFieldValue('formReserva', 'dinheiro', false);
            this.props.changeFieldValue('formReserva', 'pix', false);
            this.props.changeFieldValue('formReserva', 'pagamentoLink', false);            
            this.props.changeFieldValue('formReserva', 'pagamentoCieloEcommerce', false);
            this.props.changeFieldValue('formReserva', 'pagamentoSicoob', false);
            this.props.changeFieldValue('formReserva', 'pagamentoStoneConnect', false);

            // limpando os valores dos inputs
            this.props.changeFieldValue('formReserva', 'valorCartaoCredito', '');
            this.props.changeFieldValue('formReserva', 'valorCartaoDebito', '');
            this.props.changeFieldValue('formReserva', 'valorPIX', '');
            this.props.changeFieldValue('formReserva', 'valorDinheiro', '');
            this.props.changeFieldValue('formReserva', 'valorLink', '');            
            this.props.changeFieldValue('formReserva', 'valorCieloEcommerce', '');
            this.props.changeFieldValue('formReserva', 'valorSicoob', '');
            this.props.changeFieldValue('formReserva', 'valorStoneConnect', '');
            this.props.changeFieldValue('formReserva', 'numeroComprovanteCredito', '');
            this.props.changeFieldValue('formReserva', 'numeroComprovanteDebito', '');
            this.props.changeFieldValue('formReserva', 'numeroComprovantePIX', '');
            this.removerArquivo('PIX');
            this.removerArquivo('CARTAO');

                // Quando desmarca TEF, limpa valorTEF
            if (prevProps.pagamentoTEF && !this.props.pagamentoTEF) {
                this.props.changeFieldValue('formReserva', 'valorTEF', '');
            }
        }

        if (!prevProps.pagamentoLink && this.props.pagamentoLink) {
            this.props.changeFieldValue(
                'formReserva',
                'valorLink',
                this.props.totalReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
            );
            this.props.changeFieldValue('formReserva', 'cartaoCredito', false);
            this.props.changeFieldValue('formReserva', 'cartaoDebito', false);
            this.props.changeFieldValue('formReserva', 'dinheiro', false);
            this.props.changeFieldValue('formReserva', 'pix', false);
            this.props.changeFieldValue('formReserva', 'pagamentoTEF', false);            
            this.props.changeFieldValue('formReserva', 'pagamentoCieloEcommerce', false);
            this.props.changeFieldValue('formReserva', 'pagamentoSicoob', false);
            this.props.changeFieldValue('formReserva', 'pagamentoStoneConnect', false);

            this.props.changeFieldValue('formReserva', 'valorCartaoCredito', '');
            this.props.changeFieldValue('formReserva', 'valorCartaoDebito', '');
            this.props.changeFieldValue('formReserva', 'valorPIX', '');
            this.props.changeFieldValue('formReserva', 'valorDinheiro', '');
            this.props.changeFieldValue('formReserva', 'valorTEF', '');            
            this.props.changeFieldValue('formReserva', 'valorCieloEcommerce', '');
            this.props.changeFieldValue('formReserva', 'valorSicoob', '');
            this.props.changeFieldValue('formReserva', 'valorStoneConnect', '');
            this.removerArquivo('PIX');
            this.removerArquivo('CARTAO');

            if (prevProps.pagamentoLink && !this.props.pagamentoLink) {
                this.props.changeFieldValue('formReserva', 'valorLink', '');
            }
        }

        if (!prevProps.pagamentoCieloEcommerce && this.props.pagamentoCieloEcommerce) {
            this.props.changeFieldValue(
                'formReserva',
                'valorCieloEcommerce',
                this.props.totalReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
            );
            this.props.changeFieldValue('formReserva', 'cartaoCredito', false);
            this.props.changeFieldValue('formReserva', 'cartaoDebito', false);
            this.props.changeFieldValue('formReserva', 'dinheiro', false);
            this.props.changeFieldValue('formReserva', 'pix', false);
            this.props.changeFieldValue('formReserva', 'pagamentoTEF', false);
            this.props.changeFieldValue('formReserva', 'pagamentoLink', false);
            this.props.changeFieldValue('formReserva', 'pagamentoCieloSmart', false);
            this.props.changeFieldValue('formReserva', 'pagamentoSicoob', false);
            this.props.changeFieldValue('formReserva', 'pagamentoStoneConnect', false);

            this.props.changeFieldValue('formReserva', 'valorCartaoCredito', '');
            this.props.changeFieldValue('formReserva', 'valorCartaoDebito', '');
            this.props.changeFieldValue('formReserva', 'valorPIX', '');
            this.props.changeFieldValue('formReserva', 'valorDinheiro', '');
            this.props.changeFieldValue('formReserva', 'valorTEF', '');
            this.props.changeFieldValue('formReserva', 'valorLink', '');
            this.props.changeFieldValue('formReserva', 'valorCieloSmart', '');
            this.props.changeFieldValue('formReserva', 'valorSicoob', '');
            this.props.changeFieldValue('formReserva', 'valorStoneConnect', '');
            this.removerArquivo('PIX');
            this.removerArquivo('CARTAO');

            if (prevProps.pagamentoCieloEcommerce && !this.props.pagamentoCieloEcommerce) {
                this.props.changeFieldValue('formReserva', 'valorCieloEcommerce', '');
            }
        }

        if (!prevProps.pagamentoSicoob && this.props.pagamentoSicoob) {
            this.props.changeFieldValue(
                'formReserva',
                'valorSicoob',
                this.props.totalReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
            );
            this.props.changeFieldValue('formReserva', 'cartaoCredito', false);
            this.props.changeFieldValue('formReserva', 'cartaoDebito', false);
            this.props.changeFieldValue('formReserva', 'dinheiro', false);
            this.props.changeFieldValue('formReserva', 'pix', false);
            this.props.changeFieldValue('formReserva', 'pagamentoTEF', false);
            this.props.changeFieldValue('formReserva', 'pagamentoLink', false);
            this.props.changeFieldValue('formReserva', 'pagamentoCieloSmart', false);
            this.props.changeFieldValue('formReserva', 'pagamentoCieloEcommerce', false);
            this.props.changeFieldValue('formReserva', 'pagamentoStoneConnect', false);

            this.props.changeFieldValue('formReserva', 'valorCartaoCredito', '');
            this.props.changeFieldValue('formReserva', 'valorCartaoDebito', '');
            this.props.changeFieldValue('formReserva', 'valorPIX', '');
            this.props.changeFieldValue('formReserva', 'valorDinheiro', '');
            this.props.changeFieldValue('formReserva', 'valorTEF', '');
            this.props.changeFieldValue('formReserva', 'valorLink', '');
            this.props.changeFieldValue('formReserva', 'valorCieloSmart', '');
            this.props.changeFieldValue('formReserva', 'valorCieloEcommerce', '');
            this.props.changeFieldValue('formReserva', 'valorStoneConnect', '');
            this.removerArquivo('PIX');
            this.removerArquivo('CARTAO');

            if (prevProps.pagamentoSicoob && !this.props.pagamentoSicoob) {
                this.props.changeFieldValue('formReserva', 'valorSicoob', '');
            }
        }

        if (!prevProps.pagamentoStoneConnect && this.props.pagamentoStoneConnect) {
            this.props.changeFieldValue(
                'formReserva',
                'valorStoneConnect',
                this.props.totalReserva.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })
            );
            this.props.changeFieldValue('formReserva', 'cartaoCredito', false);
            this.props.changeFieldValue('formReserva', 'cartaoDebito', false);
            this.props.changeFieldValue('formReserva', 'dinheiro', false);
            this.props.changeFieldValue('formReserva', 'pix', false);
            this.props.changeFieldValue('formReserva', 'pagamentoTEF', false);
            this.props.changeFieldValue('formReserva', 'pagamentoLink', false);
            this.props.changeFieldValue('formReserva', 'pagamentoCieloSmart', false);
            this.props.changeFieldValue('formReserva', 'pagamentoCieloEcommerce', false);
            this.props.changeFieldValue('formReserva', 'pagamentoSicoob', false);

            this.props.changeFieldValue('formReserva', 'valorCartaoCredito', '');
            this.props.changeFieldValue('formReserva', 'valorCartaoDebito', '');
            this.props.changeFieldValue('formReserva', 'valorPIX', '');
            this.props.changeFieldValue('formReserva', 'valorDinheiro', '');
            this.props.changeFieldValue('formReserva', 'valorTEF', '');
            this.props.changeFieldValue('formReserva', 'valorLink', '');
            this.props.changeFieldValue('formReserva', 'valorCieloSmart', '');
            this.props.changeFieldValue('formReserva', 'valorCieloEcommerce', '');
            this.props.changeFieldValue('formReserva', 'valorSicoob', '');
            this.removerArquivo('PIX');
            this.removerArquivo('CARTAO');

            // modo direto por padrão + tipo credit por padrão (decidido pelo usuário, ver plano
            // de integração Connect Stone, seção 7.2/10) -- só usa PAGAMENTO_DIRETO se estiver
            // entre os modos habilitados para a empresa, senão cai no único que sobrar.
            if (!this.props.modoStoneConnect) {
                const modosHabilitadosDefault = this.props.empresaSelecionada.modosCriacaoPedidoStoneHabilitados || [];
                const modoDefault = modosHabilitadosDefault.includes('PAGAMENTO_DIRETO')
                    ? 'PAGAMENTO_DIRETO'
                    : (modosHabilitadosDefault[0] || 'PAGAMENTO_DIRETO');
                this.props.changeFieldValue('formReserva', 'modoStoneConnect', modoDefault);
            }

            if (prevProps.pagamentoStoneConnect && !this.props.pagamentoStoneConnect) {
                this.props.changeFieldValue('formReserva', 'valorStoneConnect', '');
            }
        }
    }


    handleChange(event) {
        const file = event.target.files[0];
        if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
            return
        }
        this.converterParaBase64(file, 'CARTAO')
    }


    handleChangePix(event) {
        const file = event.target.files[0];
        if (/\.(jpe?g|png|pdf)$/i.test(file.name) === false) {
            return
        }
        this.converterParaBase64(file, 'PIX')
    }

    converterParaBase64(file, formaPagamento) {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            if (formaPagamento == 'PIX') {
                this.props.changeFieldValue('formReserva',
                    'base64ComprovantePIX', reader.result);
                this.props.changeFieldValue('formReserva',
                    'nomeComprovanteVendaPIX', file.name);
            } else {
                this.props.changeFieldValue('formReserva',
                    'base64Comprovante', reader.result);
                this.props.changeFieldValue('formReserva',
                    'nomeComprovanteVenda', file.name);
            }
        }.bind(this);
    }

    limparFormulario() {
        this.props.reset('formReserva');
        this.removerArquivo();
    }

    exibirAnexoCartao() {
        const r = this.props.cartaoCredito || this.props.cartaoDebito
        return r;
    }

    exibirAnexar() {
        if (this.props.base64Comprovante) {
            return (
                <div className="vx-pay-attachment">
                    <i className="material-icons">attach_file</i>
                    <span className="vx-pay-attachment-name">{this.props.nomeComprovanteVenda}</span>
                    {this.exibirRemoverComprovante('CARTAO')}
                </div>
            )
        }
        return (
            <div className='input-wrapper'>
                <label className='vx-pay-upload-btn' htmlFor='input-file-cartao'>
                    <i className="material-icons">upload_file</i>
                    <strong>Anexar comprovante de pagamento</strong>
                </label>
                <input id='input-file-cartao' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                       onChange={this.handleChange.bind(this)}/>
            </div>
        )
    }

    exibirAnexarPix() {
        if (this.props.base64ComprovantePIX) {
            return (
                <div className="vx-pay-attachment">
                    <i className="material-icons">attach_file</i>
                    <span className="vx-pay-attachment-name">{this.props.nomeComprovanteVendaPIX}</span>
                    {this.exibirRemoverComprovante('PIX')}
                </div>
            )
        }
        return (
            <div className='input-wrapper'>
                <label className='vx-pay-upload-btn' htmlFor='input-file-pix'>
                    <i className="material-icons">upload_file</i>
                    <strong>Anexar comprovante de pagamento</strong>
                </label>
                <input id='input-file-pix' type='file' value='' accept="image/png,image/jpeg,application/pdf"
                       onChange={this.handleChangePix.bind(this)}/>
            </div>
        )
    }

    exibirRemoverComprovante(formaPagamento) {
        return (
            <button type="button" className="vx-pay-remove-btn"
                    title='Remover'
                    onClick={() => this.removerArquivo(formaPagamento)}>
                <i className="material-icons">delete</i>
            </button>
        )
    }

    removerArquivo(formaPagamento) {
        if (formaPagamento == 'PIX') {
            this.props.changeFieldValue('formReserva',
                'base64ComprovantePIX', null);
            this.props.changeFieldValue('formReserva',
                'nomeComprovanteVendaPIX', null);
        } else {
            this.props.changeFieldValue('formReserva',
                'base64Comprovante', null);
            this.props.changeFieldValue('formReserva',
                'nomeComprovanteVenda', null);
        }
    }

    handleCheckDinheiro() {
        const dinheiro = !this.props.dinheiro;
        this.props.changeFieldValue('formReserva',
            'dinheiro', dinheiro);

        this.props.changeFieldValue('formReserva',
            'valorDinheiro', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));

        this.props.verificarSeFormaPagamentoNaoFoiSelecionado(dinheiro, this.props.cartaoCredito, this.props.cartaoDebito, this.props.pix);
    }


    handleCheckCartaoCredito() {
        const cartaoCredito = !this.props.cartaoCredito;
        this.props.changeFieldValue('formReserva', 'cartaoCredito', cartaoCredito);

        this.props.changeFieldValue('formReserva',
            'valorCartaoCredito', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));

        this.props.verificarSeFormaPagamentoNaoFoiSelecionado(this.props.dinheiro, this.props.cartaoCredito, this.props.cartaoDebito, this.props.pix);
    }

    handleCheckTEF() {
            const pagamentoTEF = !this.props.pagamentoTEF;
            if(!pagamentoTEF){
                this.props.changeFieldValue('formReserva','dinheiro', true);
                this.props.changeFieldValue('formReserva',
                            'valorDinheiro', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));
            }else{
                this.props.changeFieldValue('formReserva', 'valorTEF', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));
            }
            this.props.changeFieldValue('formReserva', 'pagamentoTEF', pagamentoTEF);
        }

    handleCheckLink() {
        const pagamentoLink = !this.props.pagamentoLink;
        if(!pagamentoLink){
            this.props.changeFieldValue('formReserva', 'dinheiro', true);
            this.props.changeFieldValue('formReserva',
                        'valorDinheiro', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));
        }else{
            this.props.changeFieldValue('formReserva', 'valorLink', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));
        }
        this.props.changeFieldValue('formReserva', 'pagamentoLink', pagamentoLink);
    }

    handleCheckCieloEcommerce() {
        const pagamentoCieloEcommerce = !this.props.pagamentoCieloEcommerce;
        if (!pagamentoCieloEcommerce) {
            this.props.changeFieldValue('formReserva', 'dinheiro', true);
            this.props.changeFieldValue('formReserva',
                'valorDinheiro', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));
        } else {
            this.props.changeFieldValue('formReserva', 'valorCieloEcommerce', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));
        }
        this.props.changeFieldValue('formReserva', 'pagamentoCieloEcommerce', pagamentoCieloEcommerce);
    }

    handleCheckSicoob() {
        const pagamentoSicoob = !this.props.pagamentoSicoob;
        if (!pagamentoSicoob) {
            this.props.changeFieldValue('formReserva', 'dinheiro', true);
            this.props.changeFieldValue('formReserva',
                'valorDinheiro', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));
        } else {
            this.props.changeFieldValue('formReserva', 'valorSicoob', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));
        }
        this.props.changeFieldValue('formReserva', 'pagamentoSicoob', pagamentoSicoob);
    }

    handleCheckStoneConnect() {
        const pagamentoStoneConnect = !this.props.pagamentoStoneConnect;
        if (!pagamentoStoneConnect) {
            this.props.changeFieldValue('formReserva', 'dinheiro', true);
            this.props.changeFieldValue('formReserva',
                'valorDinheiro', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));
        } else {
            this.props.changeFieldValue('formReserva', 'valorStoneConnect', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));
        }
        this.props.changeFieldValue('formReserva', 'pagamentoStoneConnect', pagamentoStoneConnect);
    }

    handleCheckCartaoDebito() {
        const cartaoDebito = !this.props.cartaoDebito;
        this.props.changeFieldValue('formReserva', 'cartaoDebito', cartaoDebito);

        this.props.changeFieldValue('formReserva',
            'valorCartaoDebito', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));

        this.props.verificarSeFormaPagamentoNaoFoiSelecionado(this.props.dinheiro, this.props.cartaoCredito, this.props.cartaoDebito, this.props.pix);
    }

    handleCheckPix() {
        const pix = !this.props.pix;
        this.props.changeFieldValue('formReserva',
            'pix', pix);

        this.props.changeFieldValue('formReserva',
                'valorPIX', this.props.totalReserva.toLocaleString('pt-br', {style: 'currency', currency: 'BRL'}));

        this.props.verificarSeFormaPagamentoNaoFoiSelecionado(this.props.dinheiro, this.props.cartaoCredito, pix);
    }

    handleAcrescimoPassagemIda(e) {
        this.props.calcularAcrescimoPassagemUsuarioIda(e.target.value);
        if (e.target.value) {
            this.props.habilitaOuDesabilitaDescontoUsuarioIda(false);
            this.props.habilitaOuDesabilitaAcrescimoPassagemIda(true);
        } else {
            this.props.habilitaOuDesabilitaAcrescimoPassagemIda(true);
            this.props.habilitaOuDesabilitaDescontoUsuarioIda(true);
        }
    }

    handleDescontoIda(e) {
        this.props.calcularDescontoUsuarioRotaIda(e.target.value)
        if (e.target.value) {
            this.props.habilitaOuDesabilitaDescontoUsuarioIda(true);
            this.props.habilitaOuDesabilitaAcrescimoPassagemIda(false);
        } else {
            this.props.habilitaOuDesabilitaAcrescimoPassagemIda(true);
            this.props.habilitaOuDesabilitaDescontoUsuarioIda(true);
        }
    }

    handleDescontoVolta(e) {
        this.props.calcularDescontoUsuarioRotaVolta(e.target.value)
        if (e.target.value) {
            this.props.habilitaOuDesabilitaDescontoUsuarioVolta(true);
            this.props.habilitaOuDesabilitaAcrescimoPassagemVolta(false);
        } else {
            this.props.habilitaOuDesabilitaAcrescimoPassagemVolta(true);
            this.props.habilitaOuDesabilitaDescontoUsuarioVolta(true);
        }
    }

    handleAcrescimoPassagemVolta(e) {
        this.props.calcularAcrescimoPassagemUsuarioVolta(e.target.value)
        if (e.target.value) {
            this.props.habilitaOuDesabilitaDescontoUsuarioVolta(false);
            this.props.habilitaOuDesabilitaAcrescimoPassagemVolta(true);
        } else {
            this.props.habilitaOuDesabilitaAcrescimoPassagemVolta(true);
            this.props.habilitaOuDesabilitaDescontoUsuarioVolta(true);
        }
    }

    validarPerfisAdminEmpresaOuGestorEmpresaOuOperadorEmpresa() {
        return (validaPerfis([getAdminEmpresa(this.props.empresaSelecionada.id)]) ||
                    (validaPerfis([getGestorEmpresa(this.props.empresaSelecionada.id)]) && validaPerfis([getOperadorRemarcacao(this.props.empresaSelecionada.id)])) ||
                        (validaPerfis([getOperadorEmpresa(this.props.empresaSelecionada.id)]) && validaPerfis([getOperadorRemarcacao(this.props.empresaSelecionada.id)])));
        
    }

    render() {
        // Colunas col-md-4 abaixo assumem que "Modo de criação do pedido" pode não aparecer
        // (só 1 modo habilitado para a empresa) -- ver uso mais abaixo.
        const modosCriacaoPedidoHabilitados = this.props.empresaSelecionada.modosCriacaoPedidoStoneHabilitados || [];
        const temDescontoOuAcrescimo = (
            (this.props.habilitadoAcrescimoPassagemIda && this.props.permiteAcrescimoMaxmoUsuarioIda() && !this.props.ehRemarcacao) ||
            (this.props.habilitadoAcrescimoPassagemVolta && this.props.permiteAcrescimoMaximoUsuarioVolta() && !this.props.ehRemarcacao) ||
            (this.props.habilitadoDescontoUsuarioIda && this.props.permiteDescontoUsuarioRotaIda() && !this.props.ehRemarcacao) ||
            (this.props.habilitadoDescontoUsuarioVolta && this.props.permiteDescontoUsuarioRotaVolta() && !this.props.ehRemarcacao)
        );

        return (
            <div>
                {/* Seção: Formas de pagamento */}
                <div className="vx-modal-section">
                    <div className="vx-modal-section-title">
                        <i className="material-icons">credit_card</i> Forma de pagamento
                    </div>
                    <div className="vx-pay-methods-grid">
                        {/* Dinheiro — visível se não desativado pela empresa nem pelo usuário */}
                        {!(this.props.pagamentosDesativados || []).includes('DINHEIRO')
                          && !(this.props.pagamentosDesativadosUsuario || []).includes('DINHEIRO') && (
                        <div className="vx-pay-method-tile">
                            <i className="material-icons">payments</i>
                            <Field name="dinheiro" type="checkbox" component={renderFieldCheck}
                                   label="Dinheiro"
                                   css="form-check-input" readOnly={false}
                                   className="form-check-input" disabled={false}
                                   onChange={() => this.handleCheckDinheiro()}/>
                        </div>
                        )}
                        {/* Cartão de Crédito — por permissão */}
                        {!(this.props.pagamentosDesativados || []).includes('CARTAO_CREDITO')
                          && !(this.props.pagamentosDesativadosUsuario || []).includes('CARTAO_CREDITO')
                          && !this.props.pagamentoTEF && !this.props.ehPerfilVendedorAgencia && (
                            <div className="vx-pay-method-tile">
                                <i className="material-icons">credit_card</i>
                                <Field name="cartaoCredito" type="checkbox" component={renderFieldCheck}
                                       label="Cartão de Crédito"
                                       css="form-check-input" readOnly={this.props.ehPerfilVendedorAgencia}
                                       className="form-check-input" disabled={this.props.ehPerfilVendedorAgencia}
                                       onChange={() => this.handleCheckCartaoCredito()}/>
                            </div>
                        )}
                        {/* Cartão de Débito — por permissão */}
                        {!(this.props.pagamentosDesativados || []).includes('CARTAO_DEBITO')
                          && !(this.props.pagamentosDesativadosUsuario || []).includes('CARTAO_DEBITO')
                          && !this.props.pagamentoTEF && !this.props.ehPerfilVendedorAgencia && (
                            <div className="vx-pay-method-tile">
                                <i className="material-icons">credit_card</i>
                                <Field name="cartaoDebito" type="checkbox" component={renderFieldCheck}
                                       label="Cartão de Débito"
                                       css="form-check-input" readOnly={this.props.ehPerfilVendedorAgencia}
                                       className="form-check-input" disabled={this.props.ehPerfilVendedorAgencia}
                                       onChange={() => this.handleCheckCartaoDebito()}/>
                            </div>
                        )}
                        {/* PIX — por permissão */}
                        {!(this.props.pagamentosDesativados || []).includes('PIX')
                          && !(this.props.pagamentosDesativadosUsuario || []).includes('PIX')
                          && !this.props.pagamentoTEF && !this.props.ehPerfilVendedorAgencia
                          && !this.props.usuariosEmpresa.habilitadoCieloEcommerce
                          && !this.props.usuariosEmpresa.habilitadoSicoob && (
                            <div className="vx-pay-method-tile">
                                <i className="material-icons">qr_code</i>
                                <Field name="pix" type="checkbox" component={renderFieldCheck}
                                       label="PIX"
                                       css="form-check-input" readOnly={this.props.ehPerfilVendedorAgencia}
                                       className="form-check-input" disabled={this.props.ehPerfilVendedorAgencia}
                                       onChange={() => this.handleCheckPix()}/>
                            </div>
                        )}
                        {/* TEF — habilitado pela empresa */}
                        {this.props.usuariosEmpresa.habilitadoPagamentoViaTEF && !this.props.ehPerfilVendedorAgencia && (
                            <div className="vx-pay-method-tile">
                                <i className="material-icons">point_of_sale</i>
                                <Field name="pagamentoTEF" type="checkbox" component={renderFieldCheck}
                                       label="Pagamento TEF"
                                       css="form-check-input" readOnly={this.props.ehPerfilVendedorAgencia}
                                       className="form-check-input" disabled={this.props.ehPerfilVendedorAgencia}
                                       onChange={() => this.handleCheckTEF()}/>
                            </div>
                        )}
                        {/* Link Pagamento — habilitado pela empresa e não desativado globalmente */}
                        {this.props.usuariosEmpresa.habilitadoPagamentoViaLink && !(this.props.pagamentosDesativados || []).includes('LINK_PAGAMENTO') && !this.props.ehPerfilVendedorAgencia && (
                            <div className="vx-pay-method-tile">
                                <i className="material-icons">link</i>
                                <Field name="pagamentoLink" type="checkbox" component={renderFieldCheck}
                                       label="Link Pagamento"
                                       css="form-check-input" readOnly={this.props.ehPerfilVendedorAgencia}
                                       className="form-check-input" disabled={this.props.ehPerfilVendedorAgencia}
                                       onChange={() => this.handleCheckLink()}/>
                            </div>
                        )}                        
                        {/* Cielo E-commerce PIX — habilitado para o usuário */}
                        {this.props.usuariosEmpresa.habilitadoCieloEcommerce && !this.props.ehPerfilVendedorAgencia && (
                            <div className="vx-pay-method-tile">
                                <i className="material-icons">crop_free</i>
                                <Field name="pagamentoCieloEcommerce" type="checkbox" component={renderFieldCheck}
                                       label="Cielo E-commerce PIX"
                                       css="form-check-input" readOnly={false}
                                       className="form-check-input" disabled={false}
                                       onChange={() => this.handleCheckCieloEcommerce()}/>
                            </div>
                        )}
                        {/* Sicoob PIX — habilitado para o usuário */}
                        {this.props.usuariosEmpresa.habilitadoSicoob && !this.props.ehPerfilVendedorAgencia && (
                            <div className="vx-pay-method-tile">
                                <i className="material-icons">qr_code_2</i>
                                <Field name="pagamentoSicoob" type="checkbox" component={renderFieldCheck}
                                       label="Sicoob PIX"
                                       css="form-check-input" readOnly={false}
                                       className="form-check-input" disabled={false}
                                       onChange={() => this.handleCheckSicoob()}/>
                            </div>
                        )}
                        {/* Connect Stone — habilitado para o usuário */}
                        {this.props.usuariosEmpresa.habilitadoStoneConnect && !this.props.ehPerfilVendedorAgencia && (
                            <div className="vx-pay-method-tile">
                                <i className="material-icons">tap_and_play</i>
                                <Field name="pagamentoStoneConnect" type="checkbox" component={renderFieldCheck}
                                       label="Connect Stone"
                                       css="form-check-input" readOnly={false}
                                       className="form-check-input" disabled={false}
                                       onChange={() => this.handleCheckStoneConnect()}/>
                            </div>
                        )}
                    </div>
                    {/* Zerar multa remarcação — perfil especial + remarcação */}
                    {this.props.ehRemarcacao && this.validarPerfisAdminEmpresaOuGestorEmpresaOuOperadorEmpresa() && (
                        <div className="mt-3">
                            <Field name="habilitadoZerarValorMultaRemarcacao" type="checkbox" component={renderFieldCheck}
                                   label="Zerar valor de multa remarcação"
                                   css="form-check-input" readOnly={false} className="form-check-input"
                                   onChange={(e) => this.props.handleHabilitadoZerarValorMultaRemarcacao(e)}/>
                        </div>
                    )}
                </div>

                {/* Seção: Valores */}
                <div className="vx-modal-section">
                    <div className="vx-modal-section-title">
                        <i className="material-icons">attach_money</i> Valores
                    </div>
                    <div className="vx-pay-value-row">
                        {this.props.pagamentoTEF && (
                            <div className="vx-pay-value-group">
                                <Field name="valorTEF" type="text"
                                       validate={[required, maxValueMonetario, minValueMonetario]}
                                       component={renderFieldMonetarioFormulario}
                                       css="form-control" label="Valor TEF"/>
                            </div>
                        )}
                        {this.props.pagamentoLink && (
                            <div className="vx-pay-value-group">
                                <Field name="valorLink" type="text"
                                       validate={[required, maxValueMonetario, minValueMonetario]}
                                       component={renderFieldMonetarioFormulario}
                                       css="form-control" label="Valor Link Pagamento"/>
                            </div>
                        )}                        
                        {this.props.pagamentoCieloEcommerce && (
                            <div className="vx-pay-value-group">
                                <Field name="valorCieloEcommerce" type="text"
                                       validate={[required, maxValueMonetario, minValueMonetario]}
                                       component={renderFieldMonetarioFormulario}
                                       css="form-control" label="Valor Cielo E-commerce PIX"/>
                            </div>
                        )}
                        {this.props.pagamentoSicoob && (
                            <div className="vx-pay-value-group">
                                <Field name="valorSicoob" type="text"
                                       validate={[required, maxValueMonetario, minValueMonetario]}
                                       component={renderFieldMonetarioFormulario}
                                       css="form-control" label="Valor Sicoob PIX"/>
                            </div>
                        )}
                        {this.props.pagamentoStoneConnect && (
                            <div className="vx-pay-value-group">
                                <Field name="valorStoneConnect" type="text"
                                       validate={[required, maxValueMonetario, minValueMonetario]}
                                       component={renderFieldMonetarioFormulario}
                                       css="form-control" label="Valor Connect Stone"/>
                            </div>
                        )}
                        {this.props.dinheiro && (
                            <div className="vx-pay-value-group">
                                <Field name="valorDinheiro" type="text"
                                       validate={[required, maxValueMonetario, minValueMonetario]}
                                       component={renderFieldMonetarioFormulario}
                                       css="form-control" label="Valor em dinheiro"/>
                            </div>
                        )}
                    </div>
                    {this.props.cartaoCredito && (
                        <>
                            <div className="vx-pay-sub-title">
                                <i className="material-icons">credit_card</i> Cartão de crédito
                            </div>
                            <div className="vx-pay-value-row">
                                <div className="vx-pay-value-group">
                                    <Field name="valorCartaoCredito" type="text"
                                           validate={[required, maxValueMonetario, minValueMonetario]}
                                           component={renderFieldMonetarioFormulario}
                                           css="form-control" label="Valor em cartão de crédito"/>
                                </div>
                                <div className="vx-pay-value-group">
                                    <Field name="numeroComprovanteCredito" type="text"
                                           component={renderFieldText}
                                           css="form-control" label="Número comprovante crédito:"/>
                                </div>
                            </div>
                        </>
                    )}
                    {this.props.cartaoDebito && (
                        <>
                            <div className="vx-pay-sub-title">
                                <i className="material-icons">credit_card</i> Cartão de débito
                            </div>
                            <div className="vx-pay-value-row">
                                <div className="vx-pay-value-group">
                                    <Field name="valorCartaoDebito" type="text"
                                           validate={[required, maxValueMonetario, minValueMonetario]}
                                           component={renderFieldMonetarioFormulario}
                                           css="form-control" label="Valor em cartão de débito"/>
                                </div>
                                <div className="vx-pay-value-group">
                                    <Field name="numeroComprovanteDebito" type="text"
                                           component={renderFieldText}
                                           css="form-control" label="Número comprovante débito:"/>
                                </div>
                            </div>
                        </>
                    )}
                    {this.props.pix && (
                        <>
                            <div className="vx-pay-sub-title">
                                <i className="material-icons">qr_code</i> PIX
                            </div>
                            <div className="vx-pay-value-row">
                                <div className="vx-pay-value-group">
                                    <Field name="valorPIX" type="text"
                                           validate={[required, maxValueMonetario, minValueMonetario]}
                                           component={renderFieldMonetarioFormulario}
                                           css="form-control" label="Valor em PIX"/>
                                </div>
                                <div className="vx-pay-value-group">
                                    <Field name="numeroComprovantePIX" type="text"
                                           component={renderFieldText}
                                           css="form-control" label="Número comprovante PIX:"/>
                                </div>
                            </div>
                            {this.exibirAnexarPix()}
                        </>
                    )}
                    {this.exibirAnexoCartao() && this.exibirAnexar()}
                </div>

                {/* Seção: Connect Stone — maquininha + modo (Pagamento Direto/Listar Pedido) + tipo/parcelas.
                    Ver plano de integração Connect Stone, seção 7.2, e plano de ajustes em
                    demanda-a-fazer/stone-connect-meios-pagamento-por-empresa/ (combo de forma de
                    pagamento filtrado pelos meios habilitados na empresa). */}
                {this.props.pagamentoStoneConnect && (
                    <div className="vx-modal-section">
                        <div className="vx-modal-section-title">
                            <i className="material-icons">tap_and_play</i> Connect Stone
                        </div>
                        <div className="form-row">
                            <div className="form-group col-md-4">
                                <label>Maquininha</label>
                                <select className="form-control"
                                        value={this.props.numeroSerieDispositivoStone || ''}
                                        onChange={e => this.props.changeFieldValue('formReserva', 'numeroSerieDispositivoStone', e.target.value)}>
                                    <option value="">Selecione a maquininha</option>
                                    {this.state.dispositivosStoneUsuarioLogado.map(dispositivo => (
                                        <option key={dispositivo.id} value={dispositivo.numeroSerie}>{dispositivo.apelido}</option>
                                    ))}
                                </select>
                                {this.state.dispositivosStoneUsuarioLogado.length === 0 && (
                                    <small className="form-text text-muted">
                                        Nenhuma maquininha vinculada ao seu usuário. Solicite ao administrador da empresa.
                                    </small>
                                )}
                                {this.state.dispositivosStoneUsuarioLogado.length > 0 && !this.props.numeroSerieDispositivoStone && (
                                    <small className="form-text text-danger">
                                        Selecione uma maquininha para poder avançar.
                                    </small>
                                )}
                            </div>
                            {modosCriacaoPedidoHabilitados.length > 1 && (
                                <div className="form-group col-md-4">
                                    <label>Modo de criação do pedido</label>
                                    <div>
                                        {modosCriacaoPedidoHabilitados.includes('PAGAMENTO_DIRETO') && (
                                            <button type="button"
                                                    className={`btn btn-sm mr-2 ${(this.props.modoStoneConnect || 'PAGAMENTO_DIRETO') === 'PAGAMENTO_DIRETO' ? 'btn-laranja' : 'btn-outline-secondary'}`}
                                                    onClick={() => this.props.changeFieldValue('formReserva', 'modoStoneConnect', 'PAGAMENTO_DIRETO')}>
                                                Pagamento Direto
                                            </button>
                                        )}
                                        {modosCriacaoPedidoHabilitados.includes('LISTADO') && (
                                            <button type="button"
                                                    className={`btn btn-sm ${this.props.modoStoneConnect === 'LISTADO' ? 'btn-laranja' : 'btn-outline-secondary'}`}
                                                    onClick={() => this.props.changeFieldValue('formReserva', 'modoStoneConnect', 'LISTADO')}>
                                                Listar Pedido
                                            </button>
                                        )}
                                    </div>
                                </div>
                            )}
                            {(this.props.modoStoneConnect || 'PAGAMENTO_DIRETO') === 'PAGAMENTO_DIRETO' && (
                                <div className="form-group col-md-4">
                                    <label>Forma de pagamento na maquininha</label>
                                    <select className="form-control"
                                            value={this.props.tipoPagamentoStoneConnect || ''}
                                            onChange={e => this.props.changeFieldValue('formReserva', 'tipoPagamentoStoneConnect', e.target.value)}>
                                        <option value="">Selecione</option>
                                        {(this.props.empresaSelecionada.meiosPagamentoStoneHabilitados || []).map(valor => (
                                            <option key={valor} value={valor}>{LABEL_MEIO_PAGAMENTO_STONE[valor] || valor}</option>
                                        ))}
                                    </select>
                                </div>
                            )}
                        </div>
                        {(this.props.modoStoneConnect || 'PAGAMENTO_DIRETO') === 'PAGAMENTO_DIRETO' && this.props.tipoPagamentoStoneConnect === 'credit' && (
                            <div className="form-row">
                                <div className="form-group col-md-4">
                                    <label>Parcelas</label>
                                    <select className="form-control"
                                            value={this.props.parcelasStoneConnect || 1}
                                            onChange={e => this.props.changeFieldValue('formReserva', 'parcelasStoneConnect', Number(e.target.value))}>
                                        {Array.from(
                                            { length: this.props.empresaSelecionada.limiteParcelamentoStoneConnect || 12 },
                                            (_, i) => i + 1
                                        ).map(n => (
                                            <option key={n} value={n}>{n}x</option>
                                        ))}
                                    </select>
                                </div>
                            </div>
                        )}
                        {modosCriacaoPedidoHabilitados.length > 1 && (
                            <small className="form-text text-muted">
                                Em &quot;Listar Pedido&quot; a forma de pagamento é escolhida pelo comprador/operador diretamente na maquininha.
                            </small>
                        )}
                    </div>
                )}

                {/* Seção: Descontos e acréscimos — condicional por permissão e tipo de viagem */}
                {temDescontoOuAcrescimo && (
                    <div className="vx-modal-section">
                        <div className="vx-modal-section-title">
                            <i className="material-icons">percent</i> Descontos e acréscimos
                        </div>
                        <div className="vx-pay-discount-grid">
                            {this.props.habilitadoAcrescimoPassagemIda && this.props.permiteAcrescimoMaxmoUsuarioIda() && !this.props.ehRemarcacao && (
                                <div className="vx-pay-discount-group">
                                    <Field name='acrescimoPassagemIda'
                                           validate={[tamanhoPorcentagem]}
                                           component={renderFieldNumerosPorcentagem}
                                           onBlur={(e) => this.handleAcrescimoPassagemIda(e)}
                                           css="form-control" label="Acréscimo máximo Passagem ida (%)"/>
                                </div>
                            )}
                            {this.props.habilitadoAcrescimoPassagemVolta && this.props.permiteAcrescimoMaximoUsuarioVolta() && !this.props.ehRemarcacao && (
                                <div className="vx-pay-discount-group">
                                    <Field name='acrescimoPassagemVolta'
                                           validate={[tamanhoPorcentagem]}
                                           component={renderFieldNumerosPorcentagem}
                                           onBlur={(e) => this.handleAcrescimoPassagemVolta(e)}
                                           css="form-control" label="Acréscimo máximo Passagem volta (%)"/>
                                </div>
                            )}
                            {this.props.habilitadoDescontoUsuarioIda && this.props.permiteDescontoUsuarioRotaIda() && !this.props.ehRemarcacao && (
                                <div className="vx-pay-discount-group">
                                    <Field name='descontoIda'
                                           validate={[tamanhoPorcentagem]}
                                           component={renderFieldNumerosPorcentagem}
                                           onBlur={(e) => this.handleDescontoIda(e)}
                                           css="form-control" label="Desconto máximo para rota ida (%)"/>
                                </div>
                            )}
                            {this.props.habilitadoDescontoUsuarioVolta && this.props.permiteDescontoUsuarioRotaVolta() && !this.props.ehRemarcacao && (
                                <div className="vx-pay-discount-group">
                                    <Field name='descontoVolta'
                                           validate={[tamanhoPorcentagem]}
                                           component={renderFieldNumerosPorcentagem}
                                           onBlur={(e) => this.handleDescontoVolta(e)}
                                           css="form-control" label="Desconto máximo para rota volta (%)"/>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}

const seletor = formValueSelector('formReserva');

export function mapStateToProps(state) {    
    return {
        viagemIda: state.viagemIda,
        viagemVolta: state.viagemVolta,
        passageirosIda: state.passageirosIda,
        passageirosVolta: state.passageirosVolta,
        nomeComprovanteVenda: seletor(state, 'nomeComprovanteVenda'),
        numeroComprovante: seletor(state, 'numeroComprovante'),
        base64Comprovante: seletor(state, 'base64Comprovante'),
        nomeComprovanteVendaPIX: seletor(state, 'nomeComprovanteVendaPIX'),
        numeroComprovantePIX: seletor(state, 'numeroComprovantePIX'),
        base64ComprovantePIX: seletor(state, 'base64ComprovantePIX'),
        dinheiro: seletor(state, 'dinheiro'),
        cartao: seletor(state, 'cartao'),
        cartaoCredito: seletor(state, 'cartaoCredito'),
        cartaoDebito: seletor(state, 'cartaoDebito'),
        pagamentoTEF: seletor(state, 'pagamentoTEF'),
        pagamentoLink: seletor(state, 'pagamentoLink'),
        valorLink: seletor(state, 'valorLink'),        
        pagamentoCieloEcommerce: seletor(state, 'pagamentoCieloEcommerce'),
        valorCieloEcommerce: seletor(state, 'valorCieloEcommerce'),
        pagamentoSicoob: seletor(state, 'pagamentoSicoob'),
        valorSicoob: seletor(state, 'valorSicoob'),
        pagamentoStoneConnect: seletor(state, 'pagamentoStoneConnect'),
        valorStoneConnect: seletor(state, 'valorStoneConnect'),
        numeroSerieDispositivoStone: seletor(state, 'numeroSerieDispositivoStone'),
        modoStoneConnect: seletor(state, 'modoStoneConnect'),
        tipoPagamentoStoneConnect: seletor(state, 'tipoPagamentoStoneConnect'),
        parcelasStoneConnect: seletor(state, 'parcelasStoneConnect'),
        pix: seletor(state, 'pix'),
        descontoIda: seletor(state, 'descontoIda'),
        descontoVolta: seletor(state, 'descontoVolta'),
        acrescimoPassagemIda: seletor(state, 'acrescimoPassagemIda'),
        acrescimoPassagemVolta: seletor(state, 'acrescimoPassagemVolta'),
        habilitadoZerarValorMultaRemarcacao: seletor(state, 'habilitadoZerarValorMultaRemarcacao'),
        valorCartao: seletor(state, 'valorCartao'),
        valorCartaoCredito: seletor(state, 'valorCartaoCredito'),
        valorCartaoDebito: seletor(state, 'valorCartaoDebito'),
        valorDinheiro: seletor(state, 'valorDinheiro'),
        valorPIX: seletor(state, 'valorPIX'),
        valorTEF: seletor(state, 'valorTEF'),
        quantidadeParcelas: Number(seletor(state, 'quantidadeParcelas')),
        usuariosEmpresa: state.usuariosEmpresa,
        pagamentosDesativados: state.pagamentosDesativados.pagamentosDesativados,
        pagamentosDesativadosUsuario: state.pagamentosDesativadosUsuario.pagamentosDesativadosUsuario,
    }
}

export const mapDispatchToProps = dispatch => (
    bindActionCreators({
        changeFieldValue,
        adicionarFormasPagamento,
        listarDispositivosStoneUsuarioLogado,
    }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({
    form: 'formReserva',
    enableReinitialize: true,
    destroyOnUnmount: false,
    forceUnregisterOnUnmount: true,
    validate,
})(FormCadastrarFormaPagamento));
